import { IActionButtonsApiModel } from './api';

export class ActionButtonModel {
  id: string;
  title: string;
  imageUrl: string;
  isDefault: boolean;
  type:
    | 'link'
    | 'phone'
    | 'directions'
    | 'uber'
    | 'hotels.com'
    | 'email'
    | 'save'
    | 'saved'
    | 'share';
  phone: null | string;
  link: null | string;
  merchantId: null | string;
  merchantName: null | string;
  locationInfo: null | {
    point: {
      latitude: number;
      longitude: number;
    };
    googlePlaceId: string;
    name: string;
    address: string;
  };

  constructor(source: IActionButtonsApiModel) {
    this.id = source.id;
    this.title = source.title;
    this.imageUrl = source.image;
    this.isDefault = source.is_default;
    this.type = source.type;
    this.phone = source.phone;
    this.link = source.link;
    this.merchantId = source.merchant_id;
    this.merchantName = source.merchant_name;

    this.locationInfo = source.location_info
      ? {
          point: source.location_info.point,
          googlePlaceId: source.location_info.google_place_id,
          name: source.location_info.name,
          address: source.location_info.address,
        }
      : null;
  }
}
